export default [
  {
    icon: 'home',
    componentName: 'home',
    name: '首页',
    isFrame: true,
  },
  {
    icon: 'users1',
    componentName: 'merchant',
    name: '商户管理',
    isFrame: true,
    children:[
      {
        icon: 'circle-XS',
        componentName: 'merchantList',
        name: '商户列表',
        isFrame: true,
      },
      {
        icon: 'circle-XS',
        componentName: 'productAssociationlist',
        name: '产品关联表',
        isFrame: true,
      }
    ]
  },
  {
    icon: 'file-text1',
    componentName: 'product',
    name: '产品管理',
    isFrame: true,
    children:[
      {
        icon: 'circle-XS',
        componentName: 'productList',
        name: '产品列表',
        isFrame: true,
      },
      {
        icon: 'circle-XS',
        componentName: 'channelAssociationlist',
        name: '渠道关联表',
        isFrame: true,
      },
    ]
  },
  {
    icon: 'grid1',
    componentName: 'channelManage',
    name: '渠道管理',
    isFrame: true,
  },
  {
    icon: 'server1',
    componentName: 'orderManage',
    name: '订单管理',
    isFrame: true,
  },
  {
    icon: 'file-text1',
    componentName: 'wallet',
    name: '钱包管理',
    isFrame: true,
    children:[
      {
        icon: 'circle-XS',
        componentName: 'walletInfo',
        name: '钱包信息',
        isFrame: true,
      },
      {
        icon: 'circle-XS',
        componentName: 'customerManage',
        name: '客户管理',
        isFrame: true,
      },
      {
        icon: 'circle-XS',
        componentName: 'assetTurnover',
        name: '资产流水',
        isFrame: true,
      },
      {
        icon: 'circle-XS',
        componentName: 'apiTurnover',
        name: '商户流水',
        isFrame: true,
      }
    ]
  }
]
